import useTokens from '@/hooks/use-tokens'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'

const PAIR_SEPARATOR = '_'

const useTokenMintAddresses = (initMintAddresses: [string, string]) => {
  const router = useRouter()
  const { isLoading, tokenList, tokenListMap} = useTokens()
  const [mintAddresses, setMintAddresses] = useState(initMintAddresses)

  useEffect(() => {
    if (!['/', '/[pair]'].includes(router.pathname)) return
    if (!mintAddresses[0] || !mintAddresses[1] || isLoading) return
    const currentPairQuery = String(window.location.pathname.split('/').pop()).toLowerCase()

    const tokenIn = tokenListMap.get(mintAddresses[0])
    const tokenOut = tokenListMap.get(mintAddresses[1])

    if (!tokenIn || !tokenOut) return

    const newPairQuery = [tokenIn.symbol, tokenOut.symbol].join(PAIR_SEPARATOR)

    if (currentPairQuery.toLowerCase() === newPairQuery.toLowerCase()) return

    const searchParams = window.location.search

    window.history.replaceState({}, '', `/${router.locale}/${newPairQuery}${searchParams}`)
  }, [isLoading, tokenListMap, mintAddresses, router])

  useEffect(() => {
    if (isLoading || !tokenList) return

    const queryPair = String(window.location.pathname.split('/').pop()).toLowerCase()
    const pairs = queryPair.split(PAIR_SEPARATOR)

    if (pairs.length !== 2) return

    const [queryTokenIn, queryTokenOut] = pairs

    const foundTokenIn = tokenList.find(t => t.token_symbol.toLowerCase() === queryTokenIn)
    const foundTokenOut = tokenList.find(t => t.token_symbol.toLowerCase() === queryTokenOut)

    if (!foundTokenIn || !foundTokenOut) return

    setMintAddresses((prevMintAddresses) => {
      const [prevInAddr, prevOutAddr] = prevMintAddresses
      const newDefaultInAddr = foundTokenIn?.coin_address || prevInAddr
      const newDefaultOutAddr = foundTokenOut?.coin_address || prevOutAddr
      const isDuplicated = newDefaultInAddr === newDefaultOutAddr

      if (isDuplicated) {
        if (newDefaultInAddr === prevInAddr || newDefaultInAddr === prevOutAddr) {
          return prevMintAddresses
        }
        return [newDefaultInAddr, prevOutAddr]
      }

      return [newDefaultInAddr, newDefaultOutAddr]
    })
  }, [isLoading, tokenList])

  return { mintAddresses, setMintAddresses }
}

export default useTokenMintAddresses
